/* Shared on every page: phone menu, entrances, pausing loops on hidden tabs. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  /* gallery */
  const mains = $$('.gallery .main img'), thumbs = $$('.thumbs button');

  /* phone menu */
  const navEl = document.querySelector('.nav'), menuBtn = document.querySelector('.menu-btn');
  const setMenu = open => { navEl.classList.toggle('open', open); menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false'); menuBtn.setAttribute('aria-label', open ? 'Close menu' : 'Open menu'); };
  menuBtn.addEventListener('click', () => setMenu(!navEl.classList.contains('open')));
  navEl.querySelectorAll('ul a').forEach(a => a.addEventListener('click', () => setMenu(false)));
  document.addEventListener('click', e => { if (!navEl.contains(e.target)) setMenu(false); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') setMenu(false); });

  /* reveal choreography and living loops */
  const revealIO = new IntersectionObserver(entries => entries.forEach(e => {
    if (!e.isIntersecting) return;
    const el = e.target; el.classList.add('in'); revealIO.unobserve(el);
    setTimeout(() => el.classList.add('done'), 1000 + $$('.r', el).length * 110);
  }), { threshold: 0.12 });
  $$('.reveal').forEach(el => revealIO.observe(el));
  const loopIO = new IntersectionObserver(entries => entries.forEach(e => e.target.classList.toggle('on', e.isIntersecting)));
  $$('.reveal').forEach(el => loopIO.observe(el));
  document.addEventListener('visibilitychange', () => document.body.classList.toggle('paused', document.hidden));
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) $$('.reveal').forEach(el => el.classList.add('in', 'done'));

})();

/* Floating 15% off button: flies in after a short scroll or a few seconds, hides over the offer section, closable for the visit. */
(() => {
  const fly = document.querySelector('[data-fly]');
  if (!fly) return;
  let closed = false;
  try { closed = sessionStorage.getItem('snugp-fly-closed') === '1'; } catch (e) {}
  if (closed) return;
  fly.hidden = false;
  const offer = document.getElementById('offer');
  let waited = false;
  const overOffer = () => {
    if (!offer) return false;
    const r = offer.getBoundingClientRect();
    return r.top < innerHeight * 0.9 && r.bottom > 80;
  };
  const show = () => fly.classList.toggle('in', !closed && !overOffer() && (waited || scrollY > 400));
  addEventListener('resize', show, { passive: true });
  addEventListener('scroll', show, { passive: true });
  setTimeout(() => { waited = true; show(); }, 2500);
  fly.querySelector('.fly-x').addEventListener('click', () => {
    closed = true; show();
    try { sessionStorage.setItem('snugp-fly-closed', '1'); } catch (e) {}
  });
})();
